// styles
import { chartDashboardBoxStyle, chartDashboardType05Style } from 'styles';

// libraries
import styled from 'styled-components';

export const StyledAdminChartDashboard = styled.div`
  display: flex;
  color: var(--color-text-main);

  h2 {
    font-size: 16px;
    font-weight: 600;
  }

  .acd-wrapper {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;

    .box-twin {
      display: flex;
      flex-direction: column;
      gap: 18px;
    }

    .box-quad {
      display: flex;
      justify-content: space-between;
      gap: 18px;
    }

    .box-last-wrapper {
      ${chartDashboardBoxStyle}
      ${chartDashboardType05Style}
    }

    > div {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }

  .time-pjt-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    order: 0;

    > div {
      &:first-child {
        /* height: 295px !important; */
      }
    }
  }

  @media (min-width: 1920px) {
    .acd-wrapper {
      &.true {
        max-width: 1740px;
        width: 100%;

        > div {
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(5),
          &:nth-child(6) {
            min-width: 565px;
            width: 565px;

            > div {
              width: 100%;
              min-width: 100%;

              > div {
                width: 100%;
                min-width: 100%;
              }
            }
          }
          /* &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4) {
            min-width: 24%;
            width: 24%;

            > div {
              width: 100%;
              min-width: 100%;

              > div {
                width: 100%;
                min-width: 100%;
              }
            }
          }
        } */
        }
      }
    }
  }

  @media (max-width: 1919px) {
    .acd-wrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);

      .time-pjt-wrapper {
        order: -1;
      }

      > div {
        width: 100%;

        > div {
          width: 100%;

          > div {
            width: 100%;
          }
        }
      }

      .wing {
        width: fit-content !important;
      }

      .box-big,
      .box-quad {
        width: 100%;

        > li {
          width: 100%;

          > div {
            width: 100%;
          }
        }
      }

      .box-big {
        grid-column: span 2;
      }

      //.we-wrapper,
      //.box-last-wrapper {
      //  height: 100%;
      //}

      .swiper-container {
        width: 100%;
      }
    }
  }

  @media (max-width: 1023px) {
    .acd-wrapper {
      display: flex;
    }

    .box-last-wrapper,
    .we-wrapper {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 100% !important;

      .temp-lists {
        > li {
          min-width: 100% !important;
        }
      }
    }

    .img-graph {
      width: 100%;
    }

    .box-quad {
      flex-direction: column;
    }

    .swiper {
      height: 100% !important;
    }
  }
`;
